import script from "./CommonHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./CommonHeader.vue?vue&type=script&setup=true&lang=ts"

import "./CommonHeader.vue?vue&type=style&index=0&id=5e545fbc&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e545fbc"]])

export default __exports__